import { render, staticRenderFns } from "./ModalProductsListMobile.vue?vue&type=template&id=988589ee&scoped=true"
import script from "./ModalProductsListMobile.vue?vue&type=script&lang=js"
export * from "./ModalProductsListMobile.vue?vue&type=script&lang=js"
import style0 from "./ModalProductsListMobile.vue?vue&type=style&index=0&id=988589ee&prod&lang=scss&scoped=true"
import style1 from "./ModalProductsListMobile.vue?vue&type=style&index=1&id=988589ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "988589ee",
  null
  
)

export default component.exports